import { Component, OnInit } from '@angular/core';
import { LoopBackConfig } from '../../../../../assets/js/lb-sdk';
import { STORAGE_LOCATIONS } from '../../../../enums';
import { DomSanitizer } from '@angular/platform-browser';
import { BsModalRef } from 'ngx-bootstrap';
import { TermsAndConditionApi } from '../../../../../assets/js/lb-sdk/services/custom/TermsAndCondition';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-terms-and-conditions-accept',
  templateUrl: './terms-and-conditions-accept.component.html',
  styleUrls: ['./terms-and-conditions-accept.component.css']
})
export class TermsAndConditionsAcceptComponent implements OnInit {
  error: string;
  terms;
  loading: boolean = false;
  host:string = LoopBackConfig.getPath();
  container:string = STORAGE_LOCATIONS.TERMS_AND_CONDITIONS;

  constructor(
    public sanitizer: DomSanitizer,
    public modal: BsModalRef,
    private termsAndConditionApi: TermsAndConditionApi
  ) { }

  ngOnInit() {
    this.loading = true;
    this.error = undefined;
    this.termsAndConditionApi
      .findOne({
        order: 'uploadDate DESC'
      })
      .pipe(finalize(() => {
        this.loading = false;
      }))
      .subscribe(terms => {
        this.terms = terms;
      }, error => {
        this.error = 'Failed to load Terms And Conditions';
      });
  }

  dismiss() {
    this.modal.content.reason = 'Declined';
    this.modal.hide();
  }

  close(form) {
    if (form.valid) {
      this.modal.content.result = 'Accepted';
      this.modal.hide();
    }
  }
}
